<div class="hd-center-mini-card"
     [class.hd-center-mini-card--defined]="variant() === 'defined'"
     [class.hd-center-mini-card--undefined]="variant() === 'undefined'"
     [class.hd-center-mini-card--hover]="presentation() === 'hover'"
     [class.hd-center-mini-card--cheat-sheet]="presentation() === 'cheat-sheet'"
     [class.is-highlighted]="isHighlighted()">

  <!-- Color strip: always 5px tall; filled blocks when colorBlocks is non-empty -->
  <div class="hd-center-mini-card__color-strip">
    @for (color of colorBlocks(); track $index) {
      <div class="hd-center-mini-card__color-block" [style.background]="color"></div>
    }
  </div>

  <!-- Middle row: icon + text column -->
  <div class="hd-center-mini-card__middle">
    <!-- Left: center shape icon (height = 2 text lines) -->
    @if (showShapeIcon()) {
      <div class="hd-center-mini-card__shape-icon" [innerHTML]="shapeIconHtml()"></div>
    }

    <!-- Text column -->
    <div class="hd-center-mini-card__text">
      <!-- Line 1: center name (+ "(Open)" suffix in lighter grey) -->
      <div class="hd-center-mini-card__name-row">
        <div class="hd-center-mini-card__name">
          <!-- `__line` draagt in de cheat-sheet het achtergrondvlak, `__line-text`
               de tekst zelf (zie de scss: die moet in een aparte verflaag boven
               álle vlakken liggen). Geen witruimte binnen `__line`: een
               gecollapste spatie zou als extra padding meekleuren. -->
          <span class="hd-center-mini-card__line"
            ><span class="hd-center-mini-card__line-text"
              >{{ baseName() }}@if (openSuffix()) {
                <span class="hd-center-mini-card__open-suffix"> {{ openSuffix() }}</span>
              }</span
            ></span
          >
        </div>

        @if (showNotSelfHeader()) {
          <div class="hd-center-mini-card__not-self-header">
            <span class="hd-center-mini-card__ns-badge">{{ focusShort() }}</span>
            <span class="hd-center-mini-card__ns-text">{{ focusKeynote() }}</span>
          </div>
        }
      </div>

      <!-- Line 2: themes keynote -->
      <div class="hd-center-mini-card__themes">
        <span class="hd-center-mini-card__line"
          ><span class="hd-center-mini-card__line-text">{{ themes() }}</span></span
        >
      </div>

      <!-- Not-Self sections (undefined variant only) -->
      @if (showNotSelfLine()) {
        <!-- Line 3: Theme + first sentence (stacked when themeOnOwnLine) -->
        @if (themeOnOwnLine()) {
          <div class="hd-center-mini-card__not-self-theme">
            <span class="hd-center-mini-card__line">
              <span class="hd-center-mini-card__line-text">
                <span class="hd-center-mini-card__theme-label">{{ notSelfTheme() }}</span>
              </span>
            </span>
          </div>
          @if (notSelfFirstSentence()) {
            <div class="hd-center-mini-card__not-self-theme">
              <span class="hd-center-mini-card__line"
                ><span class="hd-center-mini-card__line-text">{{
                  notSelfFirstSentence()
                }}</span></span
              >
            </div>
          }
        } @else {
          <div class="hd-center-mini-card__not-self-theme">
            <span class="hd-center-mini-card__line">
              <span class="hd-center-mini-card__line-text">
                <span class="hd-center-mini-card__theme-label">{{ notSelfTheme() }}</span
                >@if (notSelfFirstSentence()) {
                  <span class="hd-center-mini-card__theme-sep"> | </span
                  ><span class="hd-center-mini-card__theme-sentence">{{
                    notSelfFirstSentence()
                  }}</span>
                }
              </span>
            </span>
          </div>
        }

        <!-- Line 4: Remaining sentences -->
        @if (notSelfRemainingSentences().length > 0) {
          <div class="hd-center-mini-card__not-self-sentences">
            @for (sentence of notSelfRemainingSentences(); track sentence) {
              <div>
                <span class="hd-center-mini-card__line"
                  ><span class="hd-center-mini-card__line-text">{{ sentence }}</span></span
                >
              </div>
            }
          </div>
        }

        <!-- Line 5: Open keynote (only when completely open) -->
        @if (isCompletelyOpen() && notSelfOpenSentence()) {
          <div class="hd-center-mini-card__open-keynote">
            <span class="hd-center-mini-card__line"
              ><span class="hd-center-mini-card__line-text"
                >{{ fullyOpenPrefix() }}{{ notSelfOpenSentence() }}</span
              ></span
            >
          </div>
        }
      }
    </div>
  </div>
</div>
